module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
    var headerHeight = 0;
    var groupHeight = height;
    var showGroupHeader = 'hide';

    var containerWidth2 = u.extractNum(width) + (parseInt(borderSize) * 2);
    var containerHeight2 = u.extractNum(height) + (parseInt(borderSize) * 2);

    // 1.65 is the growth rate between the container and its child
    var containerWidth = (((containerWidth2 * 1.65 )/100) + containerWidth2).toFixed(1);
    var containerHeight = (((containerHeight2 * 1.65 )/100) + containerHeight2).toFixed(1);

    if (u.isTrue(hasTitle)) {
        showGroupHeader = '';
        headerHeight = parseInt(titleHeight) + (parseInt(borderSize) * 2);
        containerHeight2 -= (parseInt(borderSize) * 2);
        if(titleText !== ''){
           containerHeight = parseFloat(containerHeight) + parseInt(titleFontSize);
        }
    }

    ; __append("\r\n")
    ;  
        let localizedTitleText = u.getLocalizedText(id, 'titleText') || titleText;  
    
    ; __append("\r\n\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control pf-selectable group has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"false\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top))
    ; __append("px;\r\n             background-color: rgba(0,0,0, 0);\r\n             height: ")
    ; __append(escapeFn( containerHeight2 ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border-radius: 0px;\r\n                border: 1px none #000000;\">\r\n\r\n    <div class=\"pf-control-core\"\r\n         style=\"height: ")
    ; __append(escapeFn( containerHeight2 ))
    ; __append("px; width: ")
    ; __append(escapeFn( containerWidth2 ))
    ; __append("px; z-index: -9999;\r\n            background-color:")
    ; __append(escapeFn(GroupBackgroundColor ))
    ; __append(";\r\n            border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n            border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;             \r\n            ")
    ; __append(escapeFn( pictureStyle ))
    ; __append(";\">\r\n\r\n        <div class=\"title groupTitle ")
    ; __append(escapeFn( showGroupHeader ))
    ; __append("\"\r\n             style=\" font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(titleFontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(titleFontSize))
    ; __append("px;\r\n                   font-style: ")
    ; __append(escapeFn(titleTextStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(titleTextWeight))
    ; __append(";\r\n                   color: ")
    ; __append(escapeFn(titleColor))
    ; __append(";\r\n                   text-align:")
    ; __append(escapeFn( titleAlign ))
    ; __append(";background-color:")
    ; __append(escapeFn(titleBackgroundColor))
    ; __append(";\r\n                   border: 0px !important;\r\n                   border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px !important;\r\n                   border-bottom-width: 0px !important;\r\n                   border-bottom-left-radius: 0px !important;\r\n                   border-bottom-right-radius: 0px !important;\r\n                   padding: 3px 8px 3px 8px;\r\n                   margin-bottom: 0px;\r\n                   height: ")
    ; __append(escapeFn(headerHeight ))
    ; __append("px;\r\n                   display: inline-grid;\r\n                   width: 100%;\r\n                   align-items: center;\r\n                   overflow: hidden;\">\r\n            ")
    ; __append(escapeFn(localizedTitleText))
    ; __append("</div>\r\n\r\n            <canvas class=\"group-canvas page-selection-background pf-control has-menu\" style=\"overflow: scroll; cursor: default;\" width=\"")
    ; __append(escapeFn(containerWidth2))
    ; __append("\" height=\"")
    ; __append(escapeFn(containerHeight2))
    ; __append("\"> This browser does not support the HTML5 canvas tag. HTML canvas.</canvas>\r\n\r\n            <div id=\"groupItems")
    ; __append(escapeFn( id ))
    ; __append("\"></div>\r\n    </div>\r\n    \r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( containerWidth  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( containerHeight ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( containerHeight ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( containerWidth  ))
    ; __append("px;\"></div>\r\n\r\n</div>\r\n")
  }
  return __output;

}